import ButtonWhite from 'components/design/Form/ButtonWhite/index'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import LinkPurple from '../../design/Form/LinkPurple'
import authStyle from '../../../layouts/Auth/style.module.scss'
import style from './style.module.scss'

const ResetPasswordEmailSent = () => {
  const history = useHistory()
  const { search } = useLocation()
  const [registeredEmail, setRegisteredEmail] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    const queryParams = new URLSearchParams(search)
    const email = queryParams.get('email')

    if (email) {
      setRegisteredEmail(decodeURIComponent(email))
    } else {
      history.push('/forgot-password')
    }
  }, [history, search])

  const resendEmail = () => {
    if (!registeredEmail) {
      return
    }
    dispatch({
      type: 'user/REQUEST_RESET_PASSWORD_EMAIL',
      payload: { email: registeredEmail, message: 'Email resent successfully.' },
    })
  }

  return (
    <div className={style.cometchatForgotPassEmail}>
      <div className={style.cometchatForgotPassEmailContentWrapper}>
        <div className={style.cometchatForgotPassEmailHeader}>
          <div className={style.cometchatForgotPassEmailTitle}>Check Your Email</div>
          <div className={style.cometchatForgotPassEmailSubtitle}>
            {`A password reset link has been sent to ${registeredEmail}. Follow the instructions in
            the email to reset your password`}
          </div>
        </div>

        <div className={style.cometchatForgotPassEmailActions}>
          <a
            href="https://mail.google.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={style.cometchatForgotPassEmailActionLink}
          >
            <ButtonWhite
              buttonStyles={{
                width: '100%',
                height: '44px',
                fontWeight: 600,
                fontSize: '16px',
                color: '#414651',
                borderRadius: '8px',
              }}
              buttonText={
                <>
                  <img
                    className={style.cometchatForgotPassEmailActionLinkImg}
                    src="/resources/images/v2-dashboard/gmail.svg"
                    alt="Gmail"
                  />
                  Open Gmail
                </>
              }
              buttonType="button"
            />
          </a>

          <a
            href="https://outlook.live.com/mail"
            target="_blank"
            rel="noopener noreferrer"
            className={style.cometchatForgotPassEmailActionLink}
          >
            <ButtonWhite
              buttonStyles={{
                width: '100%',
                height: '44px',
                fontWeight: 600,
                fontSize: '16px',
                color: '#414651',
                borderRadius: '8px',
              }}
              buttonText={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img
                    className={style.cometchatForgotPassEmailActionLinkImg}
                    src="/resources/images/v2-dashboard/outlook.svg"
                    alt="Outlook"
                  />
                  <div>Open Outlook</div>
                </div>
              }
              buttonType="button"
            />
          </a>
          <a
            href="https://mail.yahoo.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={style.cometchatForgotPassEmailActionLink}
          >
            <ButtonWhite
              buttonStyles={{
                width: '100%',
                height: '44px',
                fontWeight: 600,
                fontSize: '16px',
                color: '#414651',
                borderRadius: '8px',
              }}
              buttonText={
                <>
                  <img
                    className={style.cometchatForgotPassEmailActionLinkImg}
                    src="/resources/images/v2-dashboard/yahoo.svg"
                    alt="Yahoo"
                  />
                  Open Yahoo
                </>
              }
              buttonType="button"
            />
          </a>
          <div className={style.cometchatForgotPassEmailResend}>
            <span className={style.cometchatForgotPassEmailResendText}>
              Didn’t receive the email?
              <button
                type="button"
                className={style.cometchatForgotPassEmailResendLink}
                onClick={resendEmail}
              >
                Click to resend
              </button>
            </span>
          </div>
        </div>

        <div className={authStyle.signupLoginWrapper}>
          <LinkPurple
            to="/login"
            linktext={
              <div className={style.cometchatForgotPassEmailLogin}>
                <div className={style.cometchatForgotPassEmailLoginIcon} />
                Back to log in
              </div>
            }
            classes={authStyle.logInLink}
          />
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordEmailSent
